const initialState = {
  loadingData: false,
  paisSearching: false,
  productsData: null,
  manufacturerOptions: [],
  flNumberOptions: [],
  manDetailsModal: false,
  descriptionOptions: [],
  modelOptions: [],
  addingProduct: false,
  editingProduct: false,
  expandedCategory: false,
  editExpanded: false,
  detailsExpanded: false,
  addProductExpanded: false,
  templateExpanded: true,
  editData: false,
  addNewWaiting: true,
  useTemplate: false,
  tempContinue: true,
  saveIsReady: false,
  saveTemplateLoading: false,
  formAccDisabled: false,
  snackbarOpen: false,
  paisSelectedTemplate: {
    id: "",
    name: "",
  },
  savePaisSelectedTemplate: {
    id: "",
    name: "",
  },
  savePaisName: "",
  templateError: "",
  templateLoading: false,
  openModal: false,
  descriptionValue: "",
  noProductError: "",
  resettingData: false,
  startDeleteProduct: false,
  category: "",
  subCategory: "",
  isCreatingPais: false,
  usingTemplate: false,
  lookupProduct: false,
  multipleLookupProduct: false,
  enlargeGrid: false,
  foundProducts: [],
  addDisabled: false,
  selectedProductRow: null,
  freeSearch: "",
  productRows: [],
  rowsPerPage: 5,
  page: 1,
  addProductStarted: false,
  paisSelectedIDs: [],
};

const paisStateReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_ENLARGE_GRID":
      return {
        ...state,
        enlargeGrid: action.payload,
      };
    case "ADD_PRODUCT_ROW":
      return {
        ...state,
        productRows: [...state.productRows, action.payload],
      };
    case "SET_PRODUCT_ROWS":
      return {
        ...state,
        productRows: action.payload,
      };
    case "SET_PAIS_STATE":
      return {
        ...state,
        ...action.payload,
      };
    case "SET_PAIS_SELECTED_TEMPLATE":
      return {
        ...state,
        paisSelectedTemplate: action.payload,
      };
    case "SET_SAVE_PAIS_SELECTED_TEMPLATE":
      return {
        ...state,
        savePaisSelectedTemplate: action.payload,
      };
    default:
      return state;
  }
};

export default paisStateReducer;
